import type { CSSProperties } from "react";

/** Bloc de chargement animé (shimmer défini dans global.css). */
export default function Skeleton({
  width = "100%",
  height = 16,
  radius,
  style,
}: {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  style?: CSSProperties;
}) {
  return (
    <div
      className="skeleton"
      aria-hidden="true"
      style={{ width, height, ...(radius != null ? { borderRadius: radius } : {}), ...style }}
    />
  );
}
